export const enCloudDevOps = {
  // Hero Section
  title: "Cloud & DevOps Consulting Services",
  description: "End-to-end cloud transformation and DevOps implementation to accelerate your development lifecycle and infrastructure scalability.",
  subtitle: "Cloud & DevOps Solutions",

  // Services Section
  servicesTitle: "Our Cloud & DevOps Expertise",
  servicesSubtitle: "Comprehensive services to modernize your infrastructure and workflows",
  services: {
    cloudStrategy: {
      title: "Cloud Strategy",
      description: "Develop optimal cloud adoption roadmaps tailored to your business objectives.",
      technologies: ["Cloud Assessment", "TCO Analysis", "Migration Planning", "Multi-Cloud", "Hybrid Cloud"]
    },
    migration: {
      title: "Cloud Migration",
      description: "Seamless transition of applications and workloads to cloud environments.",
      technologies: ["AWS Migration", "Azure Migration", "GCP Migration", "Lift & Shift", "Replatforming"]
    },
    automation: {
      title: "DevOps Automation",
      description: "Implement CI/CD pipelines and automation for efficient software delivery.",
      technologies: ["Jenkins", "GitLab CI", "GitHub Actions", "ArgoCD", "Tekton"]
    },
    containerization: {
      title: "Containerization",
      description: "Modernize applications with container and orchestration technologies.",
      technologies: ["Docker", "Kubernetes", "ECS", "EKS", "AKS"]
    },
    monitoring: {
      title: "Cloud Monitoring",
      description: "Implement observability solutions for your cloud-native applications.",
      technologies: ["Prometheus", "Grafana", "Datadog", "New Relic", "CloudWatch"]
    },
    infrastructure: {
      title: "Infrastructure as Code",
      description: "Automate and manage infrastructure through code for consistency and reliability.",
      technologies: ["Terraform", "Pulumi", "Ansible", "CloudFormation", "Crossplane"]
    }
  },

  // Process Section
  processTitle: "Our Cloud & DevOps Process",
  processSteps: [
    {
      title: "Assessment",
      description: "Evaluate current infrastructure and identify optimization opportunities."
    },
    {
      title: "Strategy Development",
      description: "Create tailored cloud adoption and DevOps transformation plans."
    },
    {
      title: "Implementation",
      description: "Deploy cloud solutions and automate development workflows."
    },
    {
      title: "Testing",
      description: "Validate performance, security, and reliability of new infrastructure."
    },
    {
      title: "Training",
      description: "Equip teams with necessary skills for cloud and DevOps practices."
    },
    {
      title: "Ongoing Optimization",
      description: "Continuously improve and scale your cloud environment."
    }
  ]
};


export const frCloudDevOps = {
  title: "Services de Consultation Cloud & DevOps",
  description: "Transformation cloud de bout en bout et mise en œuvre de DevOps pour accélérer votre cycle de développement et la scalabilité de votre infrastructure.",
  subtitle: "Solutions Cloud & DevOps",

  servicesTitle: "Notre Expertise Cloud & DevOps",
  servicesSubtitle: "Services complets pour moderniser votre infrastructure et vos workflows",
  services: {
    cloudStrategy: {
      title: "Stratégie Cloud",
      description: "Développer des feuilles de route d'adoption cloud optimales adaptées à vos objectifs commerciaux.",
      technologies: ["Évaluation Cloud", "Analyse TCO", "Planification de Migration", "Multi-Cloud", "Cloud Hybride"]
    },
    migration: {
      title: "Migration Cloud",
      description: "Transition transparente des applications et des charges de travail vers des environnements cloud.",
      technologies: ["Migration AWS", "Migration Azure", "Migration GCP", "Lift & Shift", "Replatforming"]
    },
    automation: {
      title: "Automatisation DevOps",
      description: "Mettre en œuvre des pipelines CI/CD et de l'automatisation pour une livraison logicielle efficace.",
      technologies: ["Jenkins", "GitLab CI", "GitHub Actions", "ArgoCD", "Tekton"]
    },
    containerization: {
      title: "Containerisation",
      description: "Moderniser les applications avec des technologies de conteneur et d'orchestration.",
      technologies: ["Docker", "Kubernetes", "ECS", "EKS", "AKS"]
    },
    monitoring: {
      title: "Surveillance Cloud",
      description: "Mettre en œuvre des solutions d'observabilité pour vos applications cloud-native.",
      technologies: ["Prometheus", "Grafana", "Datadog", "New Relic", "CloudWatch"]
    },
    infrastructure: {
      title: "Infrastructure as Code",
      description: "Automatiser et gérer l'infrastructure par le code pour la cohérence et la fiabilité.",
      technologies: ["Terraform", "Pulumi", "Ansible", "CloudFormation", "Crossplane"]
    }
  },

  processTitle: "Notre Processus Cloud & DevOps",
  processSteps: [
    {
      title: "Évaluation",
      description: "Évaluer l'infrastructure actuelle et identifier les opportunités d'optimisation."
    },
    {
      title: "Développement de Stratégie",
      description: "Créer des plans d'adoption cloud et de transformation DevOps sur mesure."
    },
    {
      title: "Mise en Œuvre",
      description: "Déployer des solutions cloud et automatiser les workflows de développement."
    },
    {
      title: "Tests",
      description: "Valider les performances, la sécurité et la fiabilité de la nouvelle infrastructure."
    },
    {
      title: "Formation",
      description: "Équiper les équipes des compétences nécessaires pour les pratiques cloud et DevOps."
    },
    {
      title: "Optimisation Continue",
      description: "Améliorer et faire évoluer en continu votre environnement cloud."
    }
  ]
};

export const nlCloudDevOps = {
  title: "Cloud- en DevOps-consultancydiensten",
  description: "End-to-end cloudtransformatie en DevOps-implementatie om uw ontwikkelingscyclus en infrastructuurschaalbaarheid te versnellen.",
  subtitle: "Cloud- en DevOps-oplossingen",
  servicesTitle: "Onze Cloud- en DevOps-expertise",
  servicesSubtitle: "Uitgebreide diensten om uw infrastructuur en workflows te moderniseren",
  services: {
    cloudStrategy: {
      title: "Cloudstrategie",
      description: "Ontwikkel optimale cloudadoptieroadmaps op maat van uw bedrijfsdoelstellingen.",
      technologies: ["Cloudbeoordeling", "TCO-analyse", "Migratieplanning", "Multi-Cloud", "Hybride Cloud"]
    },
    migration: {
      title: "Cloudmigratie",
      description: "Naadloze overgang van applicaties en workloads naar cloudomgevingen.",
      technologies: ["AWS-migratie", "Azure-migratie", "GCP-migratie", "Lift & Shift", "Replatforming"]
    },
    automation: {
      title: "DevOps-automatisering",
      description: "Implementeer CI/CD-pijplijnen en automatisering voor efficiënte softwarelevering.",
      technologies: ["Jenkins", "GitLab CI", "GitHub Actions", "ArgoCD", "Tekton"]
    },
    containerization: {
      title: "Containerisatie",
      description: "Moderniseer applicaties met container- en orkestratietechnologieën.",
      technologies: ["Docker", "Kubernetes", "ECS", "EKS", "AKS"]
    },
    monitoring: {
      title: "Cloudmonitoring",
      description: "Implementeer observeerbaarheidsoplossingen voor uw cloud-native applicaties.",
      technologies: ["Prometheus", "Grafana", "Datadog", "New Relic", "CloudWatch"]
    },
    infrastructure: {
      title: "Infrastructuur als Code",
      description: "Automatiseer en beheer infrastructuur via code voor consistentie en betrouwbaarheid.",
      technologies: ["Terraform", "Pulumi", "Ansible", "CloudFormation", "Crossplane"]
    }
  },
  processTitle: "Ons Cloud- en DevOps-proces",
  processSteps: [
    {
      title: "Evaluatie",
      description: "Evalueer de huidige infrastructuur en identificeer optimalisatiemogelijkheden."
    },
    {
      title: "Strategieontwikkeling",
      description: "Creëer op maat gemaakte cloudadoptie- en DevOps-transformatieplannen."
    },
    {
      title: "Implementatie",
      description: "Implementeer cloudoplossingen en automatiseer ontwikkelworkflows."
    },
    {
      title: "Testen",
      description: "Valideer de prestaties, beveiliging en betrouwbaarheid van de nieuwe infrastructuur."
    },
    {
      title: "Training",
      description: "Voorzie teams van de nodige vaardigheden voor cloud- en DevOps-praktijken."
    },
    {
      title: "Continue Optimalisatie",
      description: "Verbeter en schaal uw cloudomgeving continu."
    }
  ]
};
export const deCloudDevOps = {
  title: "Cloud- und DevOps-Beratungsdienste",
  description: "End-to-End-Cloud-Transformation und DevOps-Implementierung zur Beschleunigung Ihres Entwicklungszyklus und der Skalierbarkeit Ihrer Infrastruktur.",
  subtitle: "Cloud- und DevOps-Lösungen",
  servicesTitle: "Unsere Cloud- und DevOps-Expertise",
  servicesSubtitle: "Umfassende Dienstleistungen zur Modernisierung Ihrer Infrastruktur und Workflows",
  services: {
    cloudStrategy: {
      title: "Cloud-Strategie",
      description: "Entwicklung optimaler Cloud-Adoptions-Roadmaps, die auf Ihre Geschäftsziele zugeschnitten sind.",
      technologies: ["Cloud-Bewertung", "TCO-Analyse", "Migrationsplanung", "Multi-Cloud", "Hybrid-Cloud"]
    },
    migration: {
      title: "Cloud-Migration",
      description: "Nahtloser Übergang von Anwendungen und Workloads in Cloud-Umgebungen.",
      technologies: ["AWS-Migration", "Azure-Migration", "GCP-Migration", "Lift & Shift", "Replatforming"]
    },
    automation: {
      title: "DevOps-Automatisierung",
      description: "Implementierung von CI/CD-Pipelines und Automatisierung für eine effiziente Softwarebereitstellung.",
      technologies: ["Jenkins", "GitLab CI", "GitHub Actions", "ArgoCD", "Tekton"]
    },
    containerization: {
      title: "Containerisierung",
      description: "Modernisierung von Anwendungen mit Container- und Orchestrierungstechnologien.",
      technologies: ["Docker", "Kubernetes", "ECS", "EKS", "AKS"]
    },
    monitoring: {
      title: "Cloud-Monitoring",
      description: "Implementierung von Observability-Lösungen für Ihre Cloud-nativen Anwendungen.",
      technologies: ["Prometheus", "Grafana", "Datadog", "New Relic", "CloudWatch"]
    },
    infrastructure: {
      title: "Infrastructure as Code",
      description: "Automatisierung und Verwaltung von Infrastruktur über Code für Konsistenz und Zuverlässigkeit.",
      technologies: ["Terraform", "Pulumi", "Ansible", "CloudFormation", "Crossplane"]
    }
  },
  processTitle: "Unser Cloud- und DevOps-Prozess",
  processSteps: [
    {
      title: "Evaluierung",
      description: "Bewertung der aktuellen Infrastruktur und Identifizierung von Optimierungsmöglichkeiten."
    },
    {
      title: "Strategieentwicklung",
      description: "Erstellung maßgeschneiderter Cloud-Adoptions- und DevOps-Transformationspläne."
    },
    {
      title: "Implementierung",
      description: "Implementierung von Cloud-Lösungen und Automatisierung von Entwicklungs-Workflows."
    },
    {
      title: "Testen",
      description: "Validierung der Leistung, Sicherheit und Zuverlässigkeit der neuen Infrastruktur."
    },
    {
      title: "Schulung",
      description: "Ausstattung der Teams mit den erforderlichen Fähigkeiten für Cloud- und DevOps-Praktiken."
    },
    {
      title: "Kontinuierliche Optimierung",
      description: "Ständige Verbesserung und Skalierung Ihrer Cloud-Umgebung."
    }
  ]
};